import http, { API_CORE } from '../http';

export default function SimpleOrderService() {
  const createSimpleOrder = async (data) => {
    const response = await http(API_CORE).post('/simple-orders', data);
    return response.data;
  };

  const getSimpleOrders = async (params = {}) => {
    const response = await http(API_CORE).get('/simple-orders', {
      params,
    });
    return response.data;
  };

  const getSimpleOrderById = async (id) => {
    const response = await http(API_CORE).get(`/simple-orders/${id}`);
    return response.data;
  };

  const getSimpleOrdersForAdmin = async (params = {}) => {
    const response = await http(API_CORE).get('/admin/simple-orders', {
      params,
    });
    return response.data;
  };

  const getSimpleOrderByIdForAdmin = async (id) => {
    const response = await http(API_CORE).get(`/admin/simple-orders/${id}`);
    return response.data;
  };

  const updateSimpleOrderStatus = async (id, data) => {
    const response = await http(API_CORE).patch(`/admin/simple-orders/${id}/status`, data);
    return response.data;
  };

  const updateSimpleOrderNotes = async (id, data) => {
    const response = await http(API_CORE).patch(`/admin/simple-orders/${id}/notes`, data);
    return response.data;
  };

  return {
    createSimpleOrder,
    getSimpleOrders,
    getSimpleOrderById,
    getSimpleOrdersForAdmin,
    getSimpleOrderByIdForAdmin,
    updateSimpleOrderStatus,
    updateSimpleOrderNotes,
  };
}
